// extracted by mini-css-extract-plugin
export default {"outerDiv":"courses-page_outerDiv__z-mIn","cardOuterDiv":"courses-page_cardOuterDiv__+3fis","vNameText":"courses-page_vNameText__AgV-i","vDescText":"courses-page_vDescText__Kwbb3"};